import { nomeFornitoreMail } from "./webfurnitureApi";

/** Titolo del popup mail pre-invio: il nome del fornitore VERO, perche' e'
 *  quello che l'operatore legge prima di confermare un acquisto. */
export function titoloMailCompose(flow: "as" | "wf", mailFornitore: string): string {
  return flow === "as"
    ? "Conferma invio mail AllService"
    : `Conferma invio mail ${nomeFornitoreMail(mailFornitore)}`;
}
